<template>
  <div class="header">位置：{{ trail }}</div>
</template>

<script>
export default {
  props: {
    trail: String
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 55px;
  line-height: 55px;
  padding-left: 22px;
  background-color: #fff;
  font-size: 18px;
  color: #333;
  box-shadow: 0 0 3px #e0e0e0;
}
</style>




// WEBPACK FOOTER //
// src/components/public/Breadcrumb-Trail.vue